<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มกะทำงาน</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ shiftInit.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ shiftInit.title_en }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">
          รหัสกะทำงาน
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="shift.shift_code"
          :rules="[
            (v) => !!v || 'โปรดระบุรหัสกะทำงาน',
            (v) =>
              (v && v.length >= 1 && v.length <= 32) ||
              'รหัสกะทำงานต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
          ]"
          required
          clearable
          @change="checkEmpty($event, 'shift_code')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          ชื่อกะทำงาน (ไทย)
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="shift.title_th"
          :rules="[
            (v) => !!v || 'โปรดระบุชื่อกะทำงาน (ไทย)',
            (v) =>
              !v ||
              (v && v.length <= 100) ||
              'ชื่อกะทำงาน (ไทย) ต้องน้อยกว่า 100 ตัวอักษร',
          ]"
          required
          clearable
          @change="checkEmpty($event, 'title_th')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">ชื่อกะทำงาน (อังกฤษ)</label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="3"
          v-model="shift.title_en"
          :rules="[
            (v) =>
              !v ||
              (v && v.length <= 100) ||
              'ชื่อกะทำงาน (อังกฤษ) ต้องน้อยกว่า 100 ตัวอักษร',
          ]"
          clearable
          @change="checkEmpty($event, 'title_en')"
          outlined
          dense
        ></v-text-field>
        <div class="mb-6">
          <label class="body-2">เวลาเริ่มบันทึกเข้างาน</label>
          <date-picker
            class="mt-1"
            v-model="shift.attendance_start_time"
            type="time"
            format="HH:mm"
            value-type="HH:mm"
            :clearable="true"
            style="width: 100%"
          ></date-picker>
        </div>
        <div class="mb-6">
          <label class="body-2">เวลาเริ่มบันทึกเข้างาน OT</label>
          <date-picker
            class="mt-1"
            v-model="shift.pre_overtime_start_time"
            type="time"
            format="HH:mm"
            value-type="HH:mm"
            :clearable="true"
            style="width: 100%"
          ></date-picker>
        </div>
        <div class="mb-6">
          <label class="body-2">
            เวลาเริ่มงาน
            <span class="red--text"><strong>*</strong></span>
          </label>
          <div
            :class="{
              'date-picker-required':
                isTimeInInvalid || isTimeInBeforeAttendanceStartInvalid,
            }"
            style="width: 100%"
          >
            <date-picker
              class="mt-1"
              v-model="shift.time_in"
              type="time"
              format="HH:mm"
              value-type="HH:mm"
              :clearable="true"
              style="width: 100%"
            ></date-picker>
            <div v-if="isTimeInInvalid" class="caption red--text mt-1 ml-3">
              โปรดระบุเวลาเริ่มงาน
            </div>
            <div
              v-else-if="isTimeInBeforeAttendanceStartInvalid"
              class="caption red--text mt-1 ml-3"
            >
              เวลาเริ่มงานต้องเท่ากับหรือมากกว่าเวลาเริ่มบันทึกเข้างาน
            </div>
          </div>
        </div>
        <div class="mb-6">
          <label class="body-2">เวลาเริ่มสาย</label>
          <div
            :class="{
              'date-picker-required': isLateTimeBeforeTimeInInvalid,
            }"
            style="width: 100%"
          >
            <date-picker
              class="mt-1"
              v-model="shift.late_time"
              type="time"
              format="HH:mm"
              value-type="HH:mm"
              :clearable="true"
              style="width: 100%"
            ></date-picker>
            <div v-if="isLateTimeBeforeTimeInInvalid" class="caption red--text mt-1 ml-3">
              เวลาเริ่มสายต้องเท่ากับหรือมากกว่าเวลาเริ่มงาน
            </div>
          </div>
        </div>
        <div class="mb-6">
          <label class="body-2">พักออก</label>
          <date-picker
            class="mt-1"
            v-model="shift.break_start_time"
            type="time"
            format="HH:mm"
            value-type="HH:mm"
            :clearable="true"
            style="width: 100%"
          ></date-picker>
        </div>
        <div class="mb-6">
          <label class="body-2">พักเข้า</label>
          <date-picker
            class="mt-1"
            v-model="shift.break_end_time"
            type="time"
            format="HH:mm"
            value-type="HH:mm"
            :clearable="true"
            style="width: 100%"
          ></date-picker>
        </div>
        <div class="mb-6">
          <label class="body-2">
            เวลาเลิกงาน
            <span class="red--text"><strong>*</strong></span>
          </label>
          <div
            :class="{ 'date-picker-required': isTimeOutInvalid }"
            style="width: 100%"
          >
            <date-picker
              class="mt-1"
              v-model="shift.time_out"
              type="time"
              format="HH:mm"
              value-type="HH:mm"
              :clearable="true"
              style="width: 100%"
            ></date-picker>
            <div v-if="isTimeOutInvalid" class="caption red--text mt-1 ml-3">
              โปรดระบุเวลาเลิกงาน
            </div>
          </div>
        </div>
        <div class="mb-6">
          <label class="body-2">เวลาเริ่มเข้างาน OT</label>
          <div
            :class="{
              'date-picker-required': isOvertimeStartBeforePreOvertimeStartInvalid,
            }"
            style="width: 100%"
          >
            <date-picker
              class="mt-1"
              v-model="shift.overtime_start_time"
              type="time"
              format="HH:mm"
              value-type="HH:mm"
              :clearable="true"
              style="width: 100%"
            ></date-picker>
            <div v-if="isOvertimeStartBeforePreOvertimeStartInvalid" class="caption red--text mt-1 ml-3">
              เวลาเริ่มเข้างาน OT ต้องเท่ากับหรือมากกว่าเวลาเริ่มบันทึกเข้างาน OT
            </div>
          </div>
        </div>
        <div class="mb-6">
          <label class="body-2">เวลาเลิกงาน OT</label>
          <date-picker
            class="mt-1"
            v-model="shift.overtime_end_time"
            type="time"
            format="HH:mm"
            value-type="HH:mm"
            :clearable="true"
            style="width: 100%"
          ></date-picker>
        </div>
        <div class="mb-6">
          <label class="body-2"
            >OT สูงสุด (ชม.)
            <span v-if="maxOvertimeDurationDisplay">
              ({{ maxOvertimeDurationDisplay }})
            </span>
          </label>
          <date-picker
            class="mt-1"
            v-model="shift.max_overtime_duration"
            type="time"
            format="HH:mm"
            value-type="HH:mm"
            :clearable="true"
            style="width: 100%"
          ></date-picker>
        </div>
        <div class="mt-6 mb-6">
          <label class="body-2 d-flex align-center mt-1 mb-0">
            <input
              class="mr-2"
              tabindex="15"
              v-model="shift.is_overtime_break_enabled"
              type="checkbox"
              @change="handleOvertimeBreakToggle"
            />
            พักทุก ๆ (ชม.)
            <span
              v-if="
                shift.is_overtime_break_enabled && overtimeBreakIntervalDisplay
              "
              class="ml-2"
            >
              ({{ overtimeBreakIntervalDisplay }})
            </span>
          </label>
          <div
            class="mt-1"
            :class="{ 'date-picker-required': isOvertimeBreakIntervalInvalid }"
            style="width: 100%"
          >
            <date-picker
              class="mt-1"
              tabindex="16"
              v-model="shift.overtime_break_interval_hours"
              type="time"
              format="HH:mm"
              value-type="HH:mm"
              :clearable="true"
              style="width: 100%"
            ></date-picker>
            <div
              v-if="isOvertimeBreakIntervalInvalid"
              class="caption red--text mt-1 ml-3"
            >
              โปรดระบุเวลาพักทุก ๆ (ชม.)
            </div>
          </div>
        </div>

        <div class="mb-6">
          <label class="body-2"
            >เวลาที่พัก (ชม.)
            <span v-if="overtimeBreakDurationDisplay">
              ({{ overtimeBreakDurationDisplay }})
            </span>
          </label>
          <date-picker
            class="mt-1"
            tabindex="17"
            v-model="shift.overtime_break_duration"
            type="time"
            format="HH:mm"
            value-type="HH:mm"
            :clearable="true"
            style="width: 100%"
          ></date-picker>
        </div>

        <div class="mb-6">
          <label class="body-2"
            >ชั่วโมงกะ (ชม.)
            <span v-if="shiftWorkingHoursDisplay">
              ({{ shiftWorkingHoursDisplay }})
            </span>
          </label>
          <date-picker
            class="mt-1"
            tabindex="18"
            v-model="shift.shift_working_hours"
            type="time"
            format="HH:mm"
            value-type="HH:mm"
            :clearable="true"
            style="width: 100%"
          ></date-picker>
        </div>

        <label class="body-2">เงินค่ากะ</label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="19"
          v-model="shift.shift_allowance"
          :rules="[
            (v) =>
              !v ||
              /^\d+(\.\d{1,2})?$/.test(String(v)) ||
              'โปรดกรอกตัวเลขเท่านั้น เช่น 50.50',
          ]"
          clearable
          @change="checkEmpty($event, 'shift_allowance')"
          outlined
          dense
        ></v-text-field>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isShiftDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::shift:delete')"
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::shift:create')"
            tabindex="20"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::shift:update')"
            tabindex="20"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn tabindex="21" depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { mapActions } from 'vuex';

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue';

export default {
  components: {
    ConfirmDialog,
    DatePicker,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    shift: {
      type: Object,
    },
    shiftInit: {
      type: Object,
    },
  },
  data() {
    return {
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      isSubmitAttempted: false,
    }
  },
  watch: {
    formShow(value) {
      if (value) this.initShiftDefaults()
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isTimeInInvalid() {
      return this.isSubmitAttempted && !this.shift.time_in
    },
    isTimeInBeforeAttendanceStartInvalid() {
      if (!this.isSubmitAttempted) return false
      if (!this.shift.time_in || !this.shift.attendance_start_time) return false

      const timeInMinutes = this.parseTimeToMinutes(this.shift.time_in)
      const attendanceStartMinutes = this.parseTimeToMinutes(
        this.shift.attendance_start_time
      )

      if (timeInMinutes === null || attendanceStartMinutes === null) {
        return false
      }

      return timeInMinutes < attendanceStartMinutes
    },
    isTimeOutInvalid() {
      return this.isSubmitAttempted && !this.shift.time_out
    },
    isLateTimeBeforeTimeInInvalid() {
      if (!this.isSubmitAttempted) return false
      if (!this.shift.late_time || !this.shift.time_in) return false

      const lateTimeMinutes = this.parseTimeToMinutes(this.shift.late_time)
      const timeInMinutes = this.parseTimeToMinutes(this.shift.time_in)

      if (lateTimeMinutes === null || timeInMinutes === null) return false

      return lateTimeMinutes < timeInMinutes
    },
    isOvertimeStartBeforePreOvertimeStartInvalid() {
      if (!this.isSubmitAttempted) return false
      if (!this.shift.overtime_start_time || !this.shift.pre_overtime_start_time)
        return false

      const overtimeStartMinutes = this.parseTimeToMinutes(
        this.shift.overtime_start_time
      )
      const preOvertimeStartMinutes = this.parseTimeToMinutes(
        this.shift.pre_overtime_start_time
      )

      if (overtimeStartMinutes === null || preOvertimeStartMinutes === null) {
        return false
      }

      return overtimeStartMinutes < preOvertimeStartMinutes
    },
    isOvertimeBreakIntervalInvalid() {
      return (
        this.isSubmitAttempted &&
        this.shift.is_overtime_break_enabled &&
        !this.shift.overtime_break_interval_hours
      )
    },
    maxOvertimeDurationDisplay() {
      const value = this.shift?.max_overtime_duration
      if (!value || typeof value !== 'string') return ''

      const [hoursText, minutesText] = value.split(':')
      const hours = Number(hoursText)
      const minutes = Number(minutesText)

      if (Number.isNaN(hours) || Number.isNaN(minutes)) return ''

      if (hours > 0 && minutes > 0) {
        return `${hours} ชั่วโมง ${minutes} นาที`
      }

      if (hours > 0) {
        return `${hours} ชั่วโมง`
      }

      if (minutes > 0) {
        return `${minutes} นาที`
      }

      return '0 นาที'
    },
    overtimeBreakIntervalDisplay() {
      const value = this.shift?.overtime_break_interval_hours
      if (!value || typeof value !== 'string') return ''

      const [hoursText, minutesText] = value.split(':')
      const hours = Number(hoursText)
      const minutes = Number(minutesText)

      if (Number.isNaN(hours) || Number.isNaN(minutes)) return ''

      if (hours > 0 && minutes > 0) {
        return `${hours} ชั่วโมง ${minutes} นาที`
      }

      if (hours > 0) {
        return `${hours} ชั่วโมง`
      }

      if (minutes > 0) {
        return `${minutes} นาที`
      }

      return '0 นาที'
    },
    overtimeBreakDurationDisplay() {
      const value = this.shift?.overtime_break_duration
      if (!value || typeof value !== 'string') return ''

      const [hoursText, minutesText] = value.split(':')
      const hours = Number(hoursText)
      const minutes = Number(minutesText)

      if (Number.isNaN(hours) || Number.isNaN(minutes)) return ''

      if (hours > 0 && minutes > 0) {
        return `${hours} ชั่วโมง ${minutes} นาที`
      }

      if (hours > 0) {
        return `${hours} ชั่วโมง`
      }

      if (minutes > 0) {
        return `${minutes} นาที`
      }

      return '0 นาที'
    },
    shiftWorkingHoursDisplay() {
      const value = this.shift?.shift_working_hours
      if (!value || typeof value !== 'string') return ''

      const [hoursText, minutesText] = value.split(':')
      const hours = Number(hoursText)
      const minutes = Number(minutesText)

      if (Number.isNaN(hours) || Number.isNaN(minutes)) return ''

      if (hours > 0 && minutes > 0) {
        return `${hours} ชั่วโมง ${minutes} นาที`
      }

      if (hours > 0) {
        return `${hours} ชั่วโมง`
      }

      if (minutes > 0) {
        return `${minutes} นาที`
      }

      return '0 นาที'
    },
    isShiftDataChange() {
      const normalizeText = (value) =>
        value === undefined || value === null ? '' : String(value).trim()

      const normalizeTime = (value) =>
        value === undefined || value === null ? null : value

      const normalizeBoolean = (value) => Boolean(value)

      if (this.formAction === 'add') {
        const hasValue =
          normalizeText(this.shift.shift_code) !== '' ||
          normalizeText(this.shift.title_th) !== '' ||
          normalizeText(this.shift.title_en) !== '' ||
          normalizeTime(this.shift.attendance_start_time) !== null ||
          normalizeTime(this.shift.pre_overtime_start_time) !== null ||
          normalizeTime(this.shift.time_in) !== null ||
          normalizeTime(this.shift.late_time) !== null ||
          normalizeTime(this.shift.break_start_time) !== null ||
          normalizeTime(this.shift.break_end_time) !== null ||
          normalizeTime(this.shift.time_out) !== null ||
          normalizeTime(this.shift.overtime_start_time) !== null ||
          normalizeTime(this.shift.overtime_end_time) !== null ||
          normalizeTime(this.shift.max_overtime_duration) !== null ||
          normalizeBoolean(this.shift.is_rotating_shift) ||
          normalizeBoolean(this.shift.is_overtime_break_enabled) ||
          normalizeTime(this.shift.overtime_break_interval_hours) !== null ||
          normalizeTime(this.shift.overtime_break_duration) !== null ||
          normalizeTime(this.shift.shift_working_hours) !== null ||
          normalizeText(this.shift.shift_allowance) !== ''

        this.$emit('isShiftDataChange', hasValue)
        return hasValue
      }

      if (
        normalizeText(this.shift.shift_code) !==
          normalizeText(this.shiftInit.shift_code) ||
        normalizeText(this.shift.title_th) !==
          normalizeText(this.shiftInit.title_th) ||
        normalizeText(this.shift.title_en) !==
          normalizeText(this.shiftInit.title_en) ||
        normalizeBoolean(this.shift.is_rotating_shift) !==
          normalizeBoolean(this.shiftInit.is_rotating_shift) ||
        normalizeTime(this.shift.attendance_start_time) !==
          normalizeTime(this.shiftInit.attendance_start_time) ||
        normalizeTime(this.shift.pre_overtime_start_time) !==
          normalizeTime(this.shiftInit.pre_overtime_start_time) ||
        normalizeTime(this.shift.time_in) !==
          normalizeTime(this.shiftInit.time_in) ||
        normalizeTime(this.shift.late_time) !==
          normalizeTime(this.shiftInit.late_time) ||
        normalizeTime(this.shift.break_start_time) !==
          normalizeTime(this.shiftInit.break_start_time) ||
        normalizeTime(this.shift.break_end_time) !==
          normalizeTime(this.shiftInit.break_end_time) ||
        normalizeTime(this.shift.time_out) !==
          normalizeTime(this.shiftInit.time_out) ||
        normalizeTime(this.shift.overtime_start_time) !==
          normalizeTime(this.shiftInit.overtime_start_time) ||
        normalizeTime(this.shift.overtime_end_time) !==
          normalizeTime(this.shiftInit.overtime_end_time) ||
        normalizeTime(this.shift.max_overtime_duration) !==
          normalizeTime(this.shiftInit.max_overtime_duration) ||
        normalizeBoolean(this.shift.is_overtime_break_enabled) !==
          normalizeBoolean(this.shiftInit.is_overtime_break_enabled) ||
        normalizeTime(this.shift.overtime_break_interval_hours) !==
          normalizeTime(this.shiftInit.overtime_break_interval_hours) ||
        normalizeTime(this.shift.overtime_break_duration) !==
          normalizeTime(this.shiftInit.overtime_break_duration) ||
        normalizeTime(this.shift.shift_working_hours) !==
          normalizeTime(this.shiftInit.shift_working_hours) ||
        normalizeText(this.shift.shift_allowance) !==
          normalizeText(this.shiftInit.shift_allowance)
      ) {
        this.$emit('isShiftDataChange', true)
        return true
      }
      this.$emit('isShiftDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      addShift: 'shift/addShift',
      editShift: 'shift/editShift',
      deleteShift: 'shift/deleteShift',
    }),
    initShiftDefaults() {
      if (this.shift.is_rotating_shift === undefined) {
        this.shift.is_rotating_shift = false
      }

      if (this.shift.is_overtime_break_enabled === undefined) {
        this.shift.is_overtime_break_enabled = false
      }
    },
    checkEmpty(value, field) {
      if (value) {
        this.shift[field] = value.trim()
      } else if (value === '') {
        this.shift[field] = null
      }
    },
    parseTimeToMinutes(value) {
      if (!value || typeof value !== 'string') return null

      const [hoursText, minutesText] = value.split(':')
      const hours = Number(hoursText)
      const minutes = Number(minutesText)

      if (Number.isNaN(hours) || Number.isNaN(minutes)) return null

      return hours * 60 + minutes
    },
    handleOvertimeBreakToggle(value) {
      if (!value) {
        this.shift.overtime_break_interval_hours = null
      }
    },
    buildShiftPayload() {
      return {
        ...this.shift,
        title_en: this.shift.title_en || null,
        attendance_start_time: this.shift.attendance_start_time,
        pre_overtime_start_time: this.shift.pre_overtime_start_time,
        time_in: this.shift.time_in,
        late_time: this.shift.late_time,
        break_start_time: this.shift.break_start_time,
        break_end_time: this.shift.break_end_time,
        time_out: this.shift.time_out,
        overtime_start_time: this.shift.overtime_start_time,
        overtime_end_time: this.shift.overtime_end_time,
        max_overtime_duration: this.shift.max_overtime_duration,
        overtime_break_interval_hours: this.shift.is_overtime_break_enabled
          ? this.shift.overtime_break_interval_hours || null
          : null,
        overtime_break_duration: this.shift.overtime_break_duration,
        shift_working_hours: this.shift.shift_working_hours,
        shift_allowance:
          this.shift.shift_allowance === '' ||
          this.shift.shift_allowance === undefined
            ? null
            : this.shift.shift_allowance,
      }
    },
    validateRequiredTimes() {
      return (
        !this.isTimeInInvalid &&
        !this.isTimeInBeforeAttendanceStartInvalid &&
        !this.isTimeOutInvalid &&
        !this.isLateTimeBeforeTimeInInvalid &&
        !this.isOvertimeStartBeforePreOvertimeStartInvalid
      )
    },
    validateOvertimeBreakInterval() {
      return !this.isOvertimeBreakIntervalInvalid
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบกะทำงาน',
        value: this.shift.title_th,
        item: this.shift,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(shift) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.deleteShift({
        companyUUID: company_uuid,
        shiftUUID: shift.shift_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', this.formAction)
          // this.$refs.form.reset()
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      this.isSubmitAttempted = true
      if (this.$refs.form.validate()) {
        if (!this.validateRequiredTimes()) return
        if (!this.validateOvertimeBreakInterval()) return

        this.$store.state.loading = true

        const shiftPayload = this.buildShiftPayload()

        const { company_uuid } = this.$store.state.authentication.company

        this.addShift({
          companyUUID: company_uuid,
          shift: shiftPayload,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$refs.form.resetValidation()
            this.$emit('formActionCompleted', this.formAction)
            // this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onSave() {
      this.isSubmitAttempted = true
      if (this.$refs.form.validate()) {
        if (!this.validateRequiredTimes()) return
        if (!this.validateOvertimeBreakInterval()) return

        this.$store.state.loading = true

        const shiftPayload = this.buildShiftPayload()

        const { company_uuid } = this.$store.state.authentication.company

        this.editShift({
          companyUUID: company_uuid,
          shiftUUID: this.shift.shift_uuid,
          shift: shiftPayload,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$refs.form.resetValidation()
            this.$emit('formActionCompleted', this.formAction)
            // this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isShiftDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.form.resetValidation()
        this.$emit('formActionCompleted', this.formAction)
        // this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$refs.form.resetValidation()
      this.$emit('formActionCompleted', this.formAction)
      // this.$refs.form.reset()
    },
    onReset() {
      this.isSubmitAttempted = false
      if (this.formAction === 'add' || this.formAction === '') {
        this.$refs.form.resetValidation()
        // this.$refs.form.reset()
      } else {
        this.$emit('onReset', this.formAction)
      }
    },
  },
}
</script>

<style scoped>
.date-picker-required ::v-deep .mx-input {
  border-color: #f44336;
}

.date-picker-required ::v-deep .mx-input:hover,
.date-picker-required ::v-deep .mx-input:focus {
  border-color: #f44336;
}
</style>
